<ion-content [fullscreen]="true" class="page-content" color="light">
  <modal-container [breadcrumbsList]="breadcrumbsList" [formStatus]="formStatus" [hideSaveButton]="true">
    <mat-grid-list cols="8" rowHeight="36px" gutterSize="20">
      @for (section of settingsData; track $index) {
      <ng-container>
        <!-- Titolo della macrosezione -->
        <mat-grid-tile colspan="8" rowspan="1">
          <b>{{'FORM.LABELS.'+section.label | translate}}</b>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="section.rowSpan"></mat-grid-tile>
        @for (input of section.inputs; track $index) {
        <mat-grid-tile *ngIf="!input.hideSection" [colspan]="input.length" [rowspan]="input.rowspan || 1"
          style="overflow: visible;">
          <ng-container [ngSwitch]="input.type">
            <!-- Button -->
            <ion-button *ngSwitchCase="'button'" style="width: 100%; height: 100%;" mode="md" expand="block"
              [fill]="input.fill || 'solid'" [disabled]="input.disabled" (click)="input?.onSelect('')">
              {{'GENERAL.BUTTONS.'+input.label | translate}}
            </ion-button>
            <!-- Text -->
            <div *ngSwitchCase="'text'" style="width: 100%; height: 100%; display: flex;">
              <p style="width: 40%; text-align: start;">{{input.label}}</p>
              <p style="width: 60%; text-align: end;">{{input.value}}</p>
            </div>
            <!-- Select -->
            <mat-form-field appearance="outline" style="width: 100%; height: 100%;" *ngSwitchDefault>
              <mat-label>{{'FORM.LABELS.'+input.label | translate}}</mat-label>
              <!-- Forzato tipo any a malincuore a causa di errori di compilazione per via del fatto che values è presente solo in ISelectInput  -->
              <mat-select [(ngModel)]="input.selectedValue"
                (selectionChange)="input.onSelect && input.onSelect($event.value)"
                [disabled]="!$any(input).values.length">
                @for (item of $any(input).values; track item) {
                <mat-option [value]="item.id">{{input.disableTranslation ? item.label : ('FORM.LABELS.'+item.label |
                  translate)}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Checkbox -->
            <mat-checkbox [(ngModel)]="input.selectedValue" appearance="outline" style="width: 100%; height: 100%;"
              *ngSwitchCase="'checkBox'" labelPosition="after"
              (change)="input.onSelect!($event.checked)">{{'FORM.LABELS.'+input.label | translate}}</mat-checkbox>
          </ng-container>
        </mat-grid-tile>
        }
      </ng-container>
      }
    </mat-grid-list>

    @if(isSuperUser) {
    <section class="developer-azure-section" aria-labelledby="azure-infrastructure-title">
      <div class="developer-azure-section__heading">
        <b id="azure-infrastructure-title">Infrastruttura Azure</b>
      </div>

      <article class="developer-azure-card developer-azure-card--costs">
        <header class="developer-azure-card__header">
          <h3>Costi Azure &middot; ultima settimana</h3>
          <mat-icon matTooltip="Distribuzione dei costi Azure per servizio negli ultimi 7 giorni">info_outline</mat-icon>
        </header>

        @if(azureCostsLoading) {
        <div class="developer-azure-state"><ion-spinner name="crescent"></ion-spinner></div>
        } @else if(azureCostItems.length) {
        <div class="azure-costs-layout">
          <div class="azure-costs-donut">
            <div echarts [options]="azureCostsOptions" [autoResize]="true"></div>
            <strong>{{ azureCostTotal | number:'1.0-2' }} &euro;<small>Totale</small></strong>
          </div>
          <div class="azure-costs-list">
            @for(item of azureCostItems; track item.name) {
            <div class="azure-costs-list__row">
              <span><i [style.background]="item.color"></i>{{ item.name }}</span>
              <b>{{ item.value | number:'1.0-2' }} &euro;</b>
              <em>{{ item.percentage | number:'1.0-1' }}%</em>
            </div>
            }
            <div class="azure-costs-list__total">
              <span>Totale</span>
              <b>{{ azureCostTotal | number:'1.0-2' }} &euro;</b>
            </div>
          </div>
        </div>
        } @else {
        <div class="developer-azure-state">Nessun dato sui costi Azure disponibile</div>
        }
      </article>

      <article class="developer-azure-card developer-azure-card--vm">
        <header class="developer-azure-card__header">
          <h3>Stato Virtual Machines (Azure) &middot; ultima ora</h3>
          <mat-icon matTooltip="Confronto tra utilizzo medio CPU e memoria RAM libera per macchina">info_outline</mat-icon>
        </header>

        @if(azureVmMetricsLoading) {
        <div class="developer-azure-state"><ion-spinner name="crescent"></ion-spinner></div>
        } @else if(azureVmMetricsData.length) {
        <div echarts [options]="azureVmMetricsOptions" [autoResize]="true" class="azure-vm-chart"></div>
        } @else {
        <div class="developer-azure-state">Nessun dato sulle Virtual Machines disponibile</div>
        }
      </article>
    </section>
    }
  </modal-container>
</ion-content>
